/**
 * The two contexts shadcn's form parts share (which field, which item), in a
 * file of their own so form.tsx exports only components (Fast Refresh).
 *
 * @module form-context
 */
import * as React from "react"
import { FieldPath, FieldValues } from "react-hook-form"

/** The react-hook-form field a FormField wraps. */
export type FormFieldContextValue<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  name: TName
}

/** The id a FormItem gives its label, control, description and message. */
export type FormItemContextValue = {
  /** React's useId for the item; the parts' ids are built from it. */
  id: string
}

/** Which field the parts inside a FormField belong to. */
export const FormFieldContext = React.createContext<FormFieldContextValue>(
  {} as FormFieldContextValue
)

/** Which item the parts inside a FormItem belong to. */
export const FormItemContext = React.createContext<FormItemContextValue>(
  {} as FormItemContextValue
) 